<template>
    <div v-if="this.$store.state.isMobile">
        <el-row :gutter="20" v-for="(o, index) in 2" :key="o">
            <el-col :span="12"><div class="grid-content bg-purple">
                <el-card :body-style="{ left: '0px' }" shadow="hover">-->
<!--                    <img :src="list[index*2].img" class="image" @load="imgLoad">-->
                    <div style="height: 100px;width: 30px">1</div>
                    <div style="padding: 12px;">
                        <span>{{list[index*2].title}}</span>
                        <div class="bottom clearfix">
                            <time class="time" >{{list[index*2].content}}</time>
                        </div>
                        <el-button type="text" class="button">查看详情</el-button>
                    </div>
                </el-card>
            </div></el-col>
            <el-col :span="12"><div class="grid-content bg-purple">
                <el-card :body-style="{ left: '0px' }" shadow="hover">-->
                    <img :src="list[index*2+1].img" class="image" @load="imgLoad">
                    <div style="padding: 12px;">
                        <span>{{list[index*2+1].title}}</span>
                        <div class="bottom clearfix">
                            <time class="time" >{{list[index*2+1].content}}</time>
                        </div>
                        <el-button type="text" class="button">查看详情</el-button>
                    </div>
                </el-card>
            </div></el-col>
        </el-row>

    </div>
</template>

<script>
    export default {
        name: "CardM",
        data() {
            return {
                aaa: 0,
                bbb: 1,
                currentDate: new Date(),
                list:[
                    {
                        img:'http://heiline.ltd/ademo/demoImg/jianli.jpg',
                        title:'项目简介',
                        content:'富文本、个人博客',
                        href:'',
                    },
                    {
                        img:'http://heiline.ltd/ademo/demoImg/beidanci.jpg',
                        title:'背单词',
                        content:'最有效的单词记忆方式',
                        href:'',
                    },
                    {
                        img:'http://heiline.ltd/ademo/demoImg/biji.jpg',
                        title:'笔记文档',
                        content:'打造最便利的第二大脑',
                        href:'',
                    },
                    {
                        img:'http://heiline.ltd/ademo/demoImg/shujia.jpg',
                        title:'书架',
                        content:'整理出最有价值的书籍',
                        href:'',
                    },
                    {
                        img:'http://heiline.ltd/ademo/demoImg/shujia.jpg',
                        title:'书架',
                        content:'整理理出最有价值的书籍',
                        href:'',
                    },
                    {
                        img:'http://heiline.ltd/ademo/demoImg/shujia.jpg',
                        title:'书架',
                        content:'整理理出最有价值的书籍',
                        href:'',
                    },
                    {
                        img:'http://heiline.ltd/ademo/demoImg/shujia.jpg',
                        title:'书架',
                        content:'整理理出最有价值的书籍',
                        href:'',
                    },
                    {
                        img:'http://heiline.ltd/ademo/demoImg/shujia.jpg',
                        title:'书架',
                        content:'整理理出最有价值的书籍',
                        href:'',
                    },
                    {
                        img:'http://heiline.ltd/ademo/demoImg/shujia.jpg',
                        title:'书架',
                        content:'整理理出最有价值的书籍',
                        href:'',
                    },
                    {
                        img:'http://heiline.ltd/ademo/demoImg/shujia.jpg',
                        title:'书架',
                        content:'整理理出最有价值的书籍',
                        href:'',
                    },
                    {
                        img:'http://heiline.ltd/ademo/demoImg/shujia.jpg',
                        title:'书架',
                        content:'整理理出最有价值的书籍',
                        href:'',
                    },
                    {
                        img:'http://heiline.ltd/ademo/demoImg/shujia.jpg',
                        title:'书架',
                        content:'整理理出最有价值的书籍',
                        href:'',
                    },
                    {
                        img:'http://heiline.ltd/ademo/demoImg/shujia.jpg',
                        title:'书架',
                        content:'整理理出最有价值的书籍',
                        href:'',
                    },
                    {
                        img:'http://heiline.ltd/ademo/demoImg/shujia.jpg',
                        title:'书架',
                        content:'整理理出最有价值的书籍',
                        href:'',
                    },
                    {
                        img:'http://heiline.ltd/ademo/demoImg/shujia.jpg',
                        title:'书架',
                        content:'整理理出最有价值的书籍',
                        href:'',
                    },
                    {
                        img:'http://heiline.ltd/ademo/demoImg/shujia.jpg',
                        title:'书架',
                        content:'整理理出最有价值的书籍',
                        href:'',
                    },
                    {
                        img:'http://heiline.ltd/ademo/demoImg/shujia.jpg',
                        title:'书架',
                        content:'整理理出最有价值的书籍',
                        href:'',
                    },
                    {
                        img:'http://heiline.ltd/ademo/demoImg/shujia.jpg',
                        title:'书架',
                        content:'整理理出最有价值的书籍',
                        href:'',
                    },
                    {
                        img:'http://heiline.ltd/ademo/demoImg/shujia.jpg',
                        title:'书架',
                        content:'整理理出最有价值的书籍',
                        href:'',
                    },
                    {
                        img:'http://heiline.ltd/ademo/demoImg/shujia.jpg',
                        title:'书架',
                        content:'整理理出最有价值的书籍',
                        href:'',
                    },
                    {
                        img:'http://heiline.ltd/ademo/demoImg/shujia.jpg',
                        title:'书架',
                        content:'整理出最有价值的书籍',
                        href:'',
                    },
                    {
                        img:'http://heiline.ltd/ademo/demoImg/shujia.jpg',
                        title:'书架',
                        content:'整理理出最有价值的书籍',
                        href:'',
                    },



                ]
            };
        },
        computed:{
            currentIndex:function(n){
               return n+2;

            },
            fullName: function(n){
                return this.n;
            },
        },
        methods:{
            imgLoad(){
                // console.log('imgload');
                this.$emit('imgLoad')
            }
        }
    }
</script>

<style scoped>
    .time {
        font-size: 13px;
        color: #999;
    }
    .bottom {
        margin-top: 13px;
        line-height: 12px;
    }

    .button {
        padding: 0;
        /*float: right;*/
    }

    .image {
        width: 100%;
        display: block;
    }
    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both
    }




    .el-row {
        margin-bottom: 20px;
    &:last-child {
         margin-bottom: 0;
     }
    }
    .el-col {
        border-radius: 4px;
    }
    .bg-purple-dark {
        background: #99a9bf;
    }
    .bg-purple {
        background: #d3dce6;
    }
    .bg-purple-light {
        background: #e5e9f2;
    }
    .grid-content {
        border-radius: 4px;
        min-height: 36px;
    }
    .row-bg {
        padding: 10px 0;
        background-color: #f9fafc;
    }
</style>